import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import React from "react";
export default function PopularEventCellMarketsLoading(): React.ReactElement<
  React.ComponentProps<"div">,
  "div"
> {
  return (
    <div className="popular-event-cell__markets--loading">
      <LoadingSpinner />
    </div>
  );
}
